import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {CiCalendarDate, CiLocationOn} from "react-icons/ci";
import { getRequests} from "../api/RequestsAPI";
import {showError} from "../../../utils/toastHelper";
import Loading from "../../../layouts/Loading";
import Header from "../../../layouts/Header";
import Navbar from "../../../layouts/Navbar";

const currencyFormat = Intl.NumberFormat('en-US');

function Requests() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [requests, setRequests] = React.useState([]);


    const config = window.APP_CONFIG;

    React.useEffect(() => {
        const fetchData = async () => {
            try {

                const params = {
                    count: 15,
                    page: 1,
                    list: 1,
                    orderBy: 'created_at',
                    orderType: 'desc',
                }

                const  result = await getRequests(params);
                setRequests(result.data)



            } catch (err) {
                showError(err)
                setLoading(true)
            } finally {
                setLoading(false);
            }
        };
        fetchData();
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)

    }, []);


    if (loading) return <Loading />;

    return (
        <React.Fragment>

            <Header title='تاریخچه درخواست ها' hasBack={false} />

            <section className="container  mt-3 py-5 rtl px-0   ">
                <div className="row mx-2 mb-3">
                    {
                        requests.map (request => {
                            return (
                                <div className="col-12 rtl mb-2 request-row pb-2 "
                                     onClick={() => navigate(`/requests/${request.id}`)}
                                >
                                    <div className="row py-2 ">
                                        <div className="col-2 fw-bold text-small-1 text-muted border-bottom pb-3 ">
                                            <img src={request.details[0].service.image} alt={request.details[0].service.title}

                                            />
                                        </div>
                                        <div className="col-7 fw-bold text-small-1 text-muted border-bottom pb-3">
                                            {request.details[0].service.title}
                                            <div className='fw-normal text-small-2 mt-2'>
                                                <CiLocationOn className='ms-1' />
                                                {request.address?.address?.substring(0, 30)}
                                            </div>

                                        </div>
                                        <div className="col-3 text-start border-bottom pb-3">
                                            <div className='text-small-2 bg-success bg-opacity-10 text-center rounded '>
                                                {request.tracking_code}
                                            </div>
                                            <div className=' mt-3 text-center rounded bg-secondary text-small-3  bg-opacity-10' style={{color: request.last_status.color}}>
                                                {request.last_status.title}
                                            </div>

                                        </div>
                                        <div className="col-6">
                                            <div className='fw-normal text-small-2 mt-2 text-muted'>
                                                <CiCalendarDate className='ms-1' />
                                                {
                                                    request.is_urgent > 0 ?
                                                        <span className='text-danger fw-bold'>
                                                    در اسرع وقت (فوری)
                                                </span>
                                                        :
                                                        <span className="value">{request.doing_date} - {request.doing_time}</span>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-6 text-start text-secondary mt-2 text-small-1 fw-bolder">
                                            {currencyFormat.format(request.pay_amount)}
                                            &nbsp;
                                            ریال
                                        </div>
                                    </div>
                                </div>
                            )} )
                    }
                </div>

            </section>
            <Navbar />
        </React.Fragment>
    );
}

export default Requests;